<template>
    <div class="section-title">
        <span class="bracket-wrapper">
            <img class="bracket" src="~@/assets/celtic_bracket.png" />
        </span>
        <span class="title-text">
            {{ text }}
        </span>
        <span class="bracket-wrapper left">
            <img class="bracket flipped" src="~@/assets/celtic_bracket.png" />
        </span>
    </div>
</template>

<script>
export default {
    name: 'SectionTitle',
    props: ['text'],
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .section-title {
        font-family: 'IrishUncialfabeta';
    }

</style>
